import type productId from "./id";

const productEn: typeof productId = {
	product: {
		title: "Product Category",
		subtitle: "Summary of list of product categories",
		label: "Product",
		empty_state: {
			title: "No Product Category data",
			description: "Please add a new one.",
		},
		table: {
			title: "Product Category Data",
			columns: {
				created_at: "Created At",
				name: "Category Name",
				status: "Status",
			},
		},
		forms: {
			add: {
				button: "Add Product Category",
				title: "Add Product Category",
				description: "Add brand new Product Category",
				field: {
					name: {
						label: "Product Category Name",
						placeholder: "Product Category Name",
					},
				},
				toast: {
					success: {
						title: "Berhasil",
						description: "Berhasil membuat kategori produk baru!",
					},
					error: {
						title: "Failed",
						description: "Failed to create product category!",
					},
				},
			},
			edit: {
				title: "Edit Product Category",
				description: "Edit Product Category",
				info: "Product Category Information",
				fields: {
					label: "Product Category Name",
					placeholder: "Product Category Name",
				},
				toast: {
					success: {
						title: "Success",
						description: "Success to edit product category!",
					},
					error: {
						title: "Failed",
						description: "Failed to edit product category!",
					},
				},
			},
			delete: {
				title: "Delete Product Category",
				description: "Are you sure want to delete {name}?",
				toast: {
					success: {
						title: "Success",
						description: "Success to delete product category!",
					},
					error: {
						title: "Failed",
						description: "Failed to delete product category!",
					},
				},
			},
		},
		actions: {
			save: "Save",
			saving: "Saving...",
			save_changes: "Save Changes",
			saving_changes: "Saving changes...",
			delete: "Delete",
			deleting: "Deleting...",
			cancel: "Cancel",
		},
	},
};

export default productEn;
